export const formatDecimal = (n: number) => n.toFixed(1)
